/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  ArrowLeftOutlined,
  ArrowRightOutlined,
  PlusCircleOutlined,
  SaveOutlined,
} from '@ant-design/icons'
import {
  Button,
  Col,
  DatePicker,
  DatePickerProps,
  Divider,
  Form,
  Input,
  Modal,
  Row,
  Select,
  Space,
  Tooltip,
  message,
} from 'antd'
import React, { useCallback, useEffect, useState } from 'react'
import { translate } from '~/utils/locale'

import { useClientsListTask } from '~/hooks/Tasks/Create/clientsListTask'
import { useTaskType } from '~/hooks/Tasks/TaskType/useTaskType'
import HelpTooltip from '../../Misc/HelpTooltip'
import dayjs from 'dayjs'
import TimeInput from '../../Misc/TimeInput'
import { ValidateStatus } from 'antd/lib/form/FormItem'
import axios from 'axios'
import geolocationApi from '~/services/geolocationApi'
import { LatLngExpression } from 'leaflet'
import { MapContainer, Marker, TileLayer, useMap } from 'react-leaflet'
import cep from 'cep-promise'
import { useListTask } from '~/hooks/Tasks/useListTasks'
import { CreateButton } from '~/components/DefaultLayout/Buttons/buttonStyle'

interface TaskTypeProps {
  id: string
  title: string
  description: string
  duration: string
}

interface ClientProps {
  id?: string
  name: string
}

interface MapUpdateFunctionProps {
  center: LatLngExpression
  zoom: number
}

const CreateTaskSimple: React.FC = () => {
  const { createTask } = useListTask()
  const { clients, isLoading } = useClientsListTask()
  const { taskType, isLoading: isLoadingTaskType } = useTaskType()

  const [form] = Form.useForm()

  const [isModalVisible, setIsModalVisible] = useState<boolean>(false)

  const [client, setClient] = useState<ClientProps>({} as ClientProps)
  const [taskTypes, setTaskTypes] = useState<TaskTypeProps>({} as TaskTypeProps)
  const [description, setDescription] = useState('')

  const [dateTask, setDateTask] = useState<any>(dayjs(new Date()))
  const [duration, setDuration] = useState('')

  const [status, setStatus] = useState('' as ValidateStatus)
  const [zoomLevel, setZoomLevel] = useState(3)

  const [zipcode, setZipcode] = useState<string>()
  const [state, setState] = useState<string>()
  const [city, setCity] = useState<string>()
  const [neighborhood, setNeighborhood] = useState<string>()
  const [street, setStreet] = useState<string>()
  const [number, setNumber] = useState<string>()
  const [complement, setComplement] = useState<string>()

  const [latitude, setLatitude] = useState<any>(-14.235004)
  const [longitude, setLongitude] = useState<any>(-51.925282)

  const [next, setNext] = useState(false)

  const { Option } = Select

  const onChange: DatePickerProps['onChange'] = (date) => {
    setDateTask(dayjs(date).format('YYYY-MM-DDTHH:mm:ss.018Z'))
  }

  const handleTimeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setDuration(e.target.value)
  }

  const handleSelectTaskType = (value: string) => {
    const selected = taskType?.find((t) => t._id === value)
    if (selected) {
      setTaskTypes({
        id: selected._id,
        title: selected.title,
        description: selected.description,
        duration: selected.runtime,
      })
    }
  }

  const handleLinkChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const url = e.target.value

    try {
      const urlObj = new URL(url)

      if (urlObj.pathname.includes('/@')) {
        const pathParts = urlObj.pathname.split('/')
        const locationPart = pathParts.find((part) => part.startsWith('@'))

        if (locationPart) {
          const [lat, lng] = locationPart
            .slice(1)
            .split(',')
            .map((coord) => parseFloat(coord))
          if (!isNaN(lat) && !isNaN(lng)) {
            setLatitude(lat)
            setLongitude(lng)
            setZoomLevel(13)

            console.log(lat, lng)

            const urlApi = `https://nominatim.openstreetmap.org/reverse?lat=${lat}&lon=${lng}&format=json`

            try {
              const response = await axios.get(urlApi)
              const address = response.data.address

              setCity(address.city ? address.city : address.municipality)
              setState(address.state)
              setNeighborhood(address.suburb)
              setStreet(address.road)
              setZipcode(address.postcode ? address.postcode : '00000000')

              form.setFieldsValue({
                city: address.city ? address.city : address.municipality,
                state: address.state,
                neighborhood: address.suburb,
                street: address.road,
                zip_code: address.postcode ? address.postcode : '00000000',
              })
            } catch (error) {
              console.error('Error fetching geocode data', error)
            }
          }
        }
      }
    } catch (error) {
      console.error('Link inválido:', error)
    }
  }

  const stateOptions = [
    { label: 'Acre', value: 'AC' },
    { label: 'Alagoas', value: 'AL' },
    { label: 'Amapá', value: 'AP' },
    { label: 'Amazonas', value: 'AM' },
    { label: 'Bahia', value: 'BA' },
    { label: 'Ceará', value: 'CE' },
    { label: 'Espírito Santo', value: 'ES' },
    { label: 'Goiás', value: 'GO' },
    { label: 'Maranhão', value: 'MA' },
    { label: 'Mato Grosso', value: 'MT' },
    { label: 'Mato Grosso do Sul', value: 'MS' },
    { label: 'Minas Gerais', value: 'MG' },
    { label: 'Pará', value: 'PA' },
    { label: 'Paraíba', value: 'PB' },
    { label: 'Paraná', value: 'PR' },
    { label: 'Pernambuco', value: 'PE' },
    { label: 'Piauí', value: 'PI' },
    { label: 'Rio de Janeiro', value: 'RJ' },
    { label: 'Rio Grande do Norte', value: 'RN' },
    { label: 'Rio Grande do Sul', value: 'RS' },
    { label: 'Rondônia', value: 'RO' },
    { label: 'Roraima', value: 'RR' },
    { label: 'Santa Catarina', value: 'SC' },
    { label: 'São Paulo', value: 'SP' },
    { label: 'Sergipe', value: 'SE' },
    { label: 'Tocantins', value: 'TO' },
    { label: 'Distrito Federal', value: 'DF' },
  ]

  const searchCEP = useCallback(
    async (address: string) => {
      try {
        setStatus('validating')
        const cepInfo = await cep(address)

        form.setFieldsValue({
          state: cepInfo.state,
          city: cepInfo.city,
          neighborhood: cepInfo.neighborhood,
          street: cepInfo.street,
        })

        setState(cepInfo.state)
        setCity(cepInfo.city)
        setStreet(cepInfo.street)
        setNeighborhood(cepInfo.neighborhood)

        setStatus('success')
      } catch (error) {
        message.error(translate('TasksCreateAddress.zipcodeSearchErrorMessage'))
        form.resetFields()
        setState('')
        setCity('')
        setStreet('')
        setStatus('error')
      }
    },
    [form],
  )

  useEffect(() => {
    const loadMap = async () => {
      if (status === 'success') {
        try {
          const params = {
            street,
            city,
            state,
            format: 'json',
          }

          const response = await geolocationApi.get('search', { params })

          if (response.data.length > 0) {
            form.setFieldsValue({
              latitude: response.data[0].lat,
              longitude: response.data[0].lon,
            })

            setLatitude(response.data[0].lat)
            setLongitude(response.data[0].lon)

            setZoomLevel(13)
          } else {
            form.setFieldsValue({
              latitude: '',
              longitude: '',
            })

            setZoomLevel(3)

            message.warning(
              translate('TasksCreateAddress.geolocationWarningMessage'),
              10,
            )
          }
        } catch (error) {
          message.error(translate('TasksCreateAddress.geolocationErrorMessage'))
        }
      }
    }

    loadMap()
  }, [city, state, street, form, status])

  function ChangeView({ center, zoom }: MapUpdateFunctionProps) {
    const map = useMap()
    map.setView(center, zoom)
    return null
  }

  const initialValue = {
    initialDate: dayjs(new Date()),
  }

  useEffect(() => {
    if (taskTypes?.id) {
      form.setFieldsValue({
        task_type_id: taskTypes?.title,
        duration_time: taskTypes?.duration,
        description: taskTypes?.description,
      })

      setDuration(taskTypes?.duration || '')
      setDescription(taskTypes?.description || '')
    }
  }, [form, taskTypes])

  const showModal = () => {
    setIsModalVisible(true)
  }

  const handleOk = async () => {
    try {
      const dataForm = {
        task_type_id: taskTypes?.id,
        date: dateTask,
        duration_time: duration,
        description,
        customer_id: client,
        address: {
          zip_code: zipcode,
          street,
          number,
          complement,
          neighborhood,
          city,
          state,
          location: {
            x: latitude,
            y: longitude,
          },
        },
      }

      createTask(dataForm)
      form.resetFields()

      setNext(false)
      setIsModalVisible(false)
    } catch (error) {}
  }

  const handleCancel = () => {
    setIsModalVisible(false)
  }

  return (
    <>
      <Tooltip title="Criar Tarefa Simplificada">
        <CreateButton icon={<PlusCircleOutlined />} onClick={showModal} />
      </Tooltip>

      <Modal
        title={
          <>
            Criar Tarefa Simplificada
            <Divider style={{ margin: '10px 0' }} />
          </>
        }
        width="850px"
        open={isModalVisible}
        onCancel={handleCancel}
        footer={[
          <Space size="small" key="footer">
            {next && (
              <Button
                icon={<ArrowLeftOutlined />}
                onClick={() => setNext(false)}
              >
                Voltar
              </Button>
            )}

            {!next && client && taskTypes?.id && taskTypes?.duration ? (
              <Button
                type="primary"
                icon={<ArrowRightOutlined />}
                onClick={() => setNext(true)}
              >
                Próximo
              </Button>
            ) : null}

            {next && number ? (
              <Button type="primary" icon={<SaveOutlined />} onClick={handleOk}>
                Salvar
              </Button>
            ) : null}
          </Space>,
        ]}
      >
        <Form layout="vertical" initialValues={initialValue} form={form}>
          {!next ? (
            <>
              <Row gutter={14}>
                <Col span={12}>
                  <Form.Item
                    label={translate('TasksCreateDetails.clientLabel')}
                    name="customer_id"
                    rules={[
                      {
                        required: true,
                        message: translate('TasksCreateDetails.clientRule'),
                      },
                    ]}
                  >
                    <Select
                      placeholder={translate('TasksFilter.clientPlaceholder')}
                      optionFilterProp="children"
                      loading={isLoading}
                      onChange={(e) => setClient(e)}
                      showSearch
                    >
                      {clients?.map((client) => (
                        <Option value={client.id} key={client.id}>
                          {client.contact.name}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>

                <Col span={12}>
                  <Form.Item
                    label={translate('TasksCreateDetails.taskTypeLabel')}
                    name="task_type_id"
                    rules={[
                      {
                        required: true,
                        message: translate('TasksCreateDetails.taskTypeRule'),
                      },
                    ]}
                  >
                    <Select
                      placeholder={translate('TasksFilter.taskTypePlaceholder')}
                      optionFilterProp="children"
                      loading={isLoadingTaskType}
                      onChange={handleSelectTaskType}
                      showSearch
                    >
                      {taskType?.map((tasksTypes) => (
                        <Select.Option
                          key={tasksTypes?._id}
                          value={tasksTypes?._id}
                        >
                          {tasksTypes?.title}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
              </Row>

              <Row gutter={14}>
                <Col span={12}>
                  <Form.Item
                    label={
                      <Space>
                        <p>{translate('TasksCreateDetails.dateLabel')}</p>

                        <HelpTooltip
                          title={translate(
                            'TasksCreateDetails.dateHelpTooltip',
                          )}
                        />
                      </Space>
                    }
                    name="initialDate"
                    rules={[
                      {
                        required: true,
                        message: translate('TasksCreateDetails.dateRule'),
                      },
                    ]}
                  >
                    <DatePicker
                      onChange={onChange}
                      format="DD/MM/YYYY HH:mm"
                      placeholder={translate('TasksFilter.fromDatePlaceholder')}
                      style={{ width: '100%' }}
                      showTime={{ format: 'HH:mm' }}
                    />
                  </Form.Item>
                </Col>

                <Col span={12}>
                  <Form.Item
                    label={
                      <Space>
                        {translate('TasksCreateDetails.durationLabel')}
                        <HelpTooltip
                          title={translate(
                            'TasksCreateDetails.durationHelpTooltip',
                          )}
                        />
                      </Space>
                    }
                    name="duration_time"
                  >
                    <TimeInput
                      value={duration}
                      onChange={handleTimeChange}
                      placeholder="HH:mm:ss"
                    />
                  </Form.Item>
                </Col>
              </Row>

              <Row>
                <Col span={12}>
                  <Form.Item
                    label={translate('TasksCreateDetails.descriptionLabel')}
                    name="description"
                  >
                    <Input.TextArea
                      placeholder={translate(
                        'TasksCreateDetails.descriptionPlaceholder',
                      )}
                      onChange={(e) => setDescription(e.target.value)}
                    />
                  </Form.Item>
                </Col>
              </Row>
            </>
          ) : (
            <>
              <Row gutter={14}>
                <Col span={8}>
                  <Form.Item
                    label={translate('TasksCreateAddress.zipcodeLabel')}
                    name="zip_code"
                    hasFeedback
                    validateStatus={status}
                    rules={[
                      {
                        required: true,
                        message: 'Informe o cep.',
                      },
                    ]}
                  >
                    <Input
                      placeholder="00000-000"
                      onChange={(e) => {
                        const cepInput = e.target.value.replace(/\D/g, '')
                        if (cepInput.length === 8) {
                          searchCEP(e.target.value)
                          setZipcode(e.target.value)
                        }
                      }}
                    />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    label={translate('TasksCreateAddress.stateLabel')}
                    name="state"
                  >
                    <Select
                      style={{ width: '100%' }}
                      placeholder={translate(
                        'TasksCreateAddress.statePlaceholder',
                      )}
                      className="menu_input"
                      onChange={(e) => setState(String(e))}
                      options={stateOptions}
                    />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    label={translate('TasksCreateAddress.cityLabel')}
                    name="city"
                  >
                    <Input
                      placeholder={translate(
                        'TasksCreateAddress.cityPlaceholder',
                      )}
                      onChange={(e) => setCity(e.target.value)}
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={14}>
                <Col span={8}>
                  <Form.Item
                    label={translate('TasksCreateAddress.neighborhoodLabel')}
                    name="neighborhood"
                  >
                    <Input
                      placeholder={translate(
                        'TasksCreateAddress.neighborhoodPlaceholder',
                      )}
                    />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    label={translate('TasksCreateAddress.streetLabel')}
                    name="street"
                  >
                    <Input
                      placeholder={translate(
                        'TasksCreateAddress.streetPlaceholder',
                      )}
                      onChange={(e) => setStreet(e.target.value)}
                    />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    label={translate('TasksCreateAddress.numberLabel')}
                    name="number"
                    rules={[
                      {
                        required: true,
                        message: translate('TasksCreateAddress.numberRule'),
                      },
                    ]}
                  >
                    <Input
                      placeholder={translate(
                        'TasksCreateAddress.numberPlaceholder',
                      )}
                      onChange={(e) => setNumber(e.target.value)}
                    />
                  </Form.Item>
                </Col>
              </Row>

              <Row gutter={14}>
                <Col span={8}>
                  <Form.Item
                    label={translate('TasksCreateAddress.complementLabel')}
                    name="complement"
                  >
                    <Input
                      placeholder={translate(
                        'TasksCreateAddress.complementPlaceholder',
                      )}
                      onChange={(e) => setComplement(e.target.value)}
                    />
                  </Form.Item>
                </Col>

                <Col span={8}>
                  <Form.Item
                    label={
                      <Space>
                        <p>Link Google Maps</p>
                        <HelpTooltip title="Se você não souber o CEP, pode encontrá-lo facilmente no Google Maps. Basta buscar pela localização e inserir a url neste campo." />
                      </Space>
                    }
                  >
                    <Input
                      onBlur={handleLinkChange}
                      placeholder="Adicione o link do google maps"
                    />
                  </Form.Item>
                </Col>
              </Row>

              <MapContainer
                center={[latitude, longitude]}
                zoom={zoomLevel}
                scrollWheelZoom={false}
                style={{ height: '200px', width: '100%' }}
              >
                <ChangeView center={[latitude, longitude]} zoom={zoomLevel} />
                <TileLayer
                  attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                  url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                />
                {latitude !== -14.235004 && longitude !== -51.925282 && (
                  <Marker position={[latitude, longitude]} />
                )}
              </MapContainer>
            </>
          )}
        </Form>
      </Modal>
    </>
  )
}

export default CreateTaskSimple
